import React from "react";
import { App } from "../../landings/ru/index/index";
import { Helmet } from "react-helmet";
import { Translate, setCurrentLng } from "../../locales/locales-utils";
import { useLocation } from '@reach/router';

type Props = {
  lang: string;
}

export default ({ lang }: Props) => {
  const location = useLocation();
  setCurrentLng(lang);

  return (
    <>
      <Helmet title={Translate("Index.MetaData.Title")}>
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta
          name="description"
          content={Translate("Index.MetaData.Description")}
        />
        <link rel="canonical" href={location.href} />
        <link rel="icon" type="image/x-icon" href="/favicon.ico" />
      </Helmet>
      <App />
    </>
  );
};
